<template>
    <ModalOverlay @click="$emit('close')">
        <ModalContent @click.stop>
            <ModalHeader>
                <ModalTitle>고객 등록</ModalTitle>
                <ModalCloseButton @click="$emit('close')">✕</ModalCloseButton>
            </ModalHeader>
            <ModalBody>
                <RegistrationFormContainer>
                    <FormRow>
                        <FormGroup>
                            <FormLabel for="beneficiaryName">등록자명</FormLabel>
                            <FormInput type="text" id="beneficiaryName" placeholder="등록자명을 입력하세요"
                                v-model="formData.beneficiaryName">
                            </FormInput>
                        </FormGroup>
                        <FormGroup>
                            <FormLabel for="number">인정번호</FormLabel>
                            <FormInput type="text" id="number" placeholder="인정번호를 입력하세요" v-model="formData.number">
                            </FormInput>
                        </FormGroup>
                    </FormRow>

                    <FormRow>
                        <FormGroup>
                            <FormLabel for="cnum">기관기호</FormLabel>
                            <FormInput type="text" id="cnum" placeholder="기관기호를 입력하세요" v-model="formData.cnum">
                            </FormInput>
                        </FormGroup>
                        <FormGroup>
                            <FormLabel for="target">구분</FormLabel>
                            <FormSelect id="target" v-model="formData.target">
                                <option value="">구분을 선택하세요</option>
                                <option value="일반">일반</option>
                                <option value="기초">기초</option>
                                <option value="감경">감경</option>
                                <option value="의료급여">의료급여</option>
                            </FormSelect>
                        </FormGroup>
                    </FormRow>

                    <FormRow>
                        <FormGroup class="full-width">
                            <FormLabel for="address">주소</FormLabel>
                            <ModernAddressInputGroup>
                                <FormInput type="text" id="address" placeholder="주소를 입력하세요" readonly
                                    v-model="formData.address" style="width: 300px;">
                                </FormInput>
                                <ModernAddressSearchBtn type="button" @click="searchAddress">
                                    <AddressSearchIcon />
                                    주소 검색
                                </ModernAddressSearchBtn>
                            </ModernAddressInputGroup>
                            <FormInput type="text" id="address_detail" placeholder="상세주소를 입력하세요"
                                style="margin-top: 8px;" v-model="formData.address_detail">
                            </FormInput>
                        </FormGroup>
                    </FormRow>

                    <FormRow>
                        <FormGroup>
                            <FormLabel for="guard_name">보호자명</FormLabel>
                            <FormInput type="text" id="guard_name" placeholder="보호자명을 입력하세요"
                                v-model="formData.guard_name">
                            </FormInput>
                        </FormGroup>
                        <FormGroup>
                            <FormLabel for="guard_target">보호자 관계</FormLabel>
                            <FormSelect id="guard_target" v-model="formData.guard_target">
                                <option value="">관계를 선택하세요</option>
                                <option value="본인">본인</option>
                                <option value="배우자">배우자</option>
                                <option value="자녀">자녀</option>
                                <option value="부모">부모</option>
                                <option value="기타">기타</option>
                            </FormSelect>
                        </FormGroup>
                    </FormRow>

                    <FormRow>
                        <FormGroup>
                            <FormLabel for="manager">담당자</FormLabel>
                            <FormInput type="text" id="manager" placeholder="담당자를 입력하세요" v-model="formData.manager">
                            </FormInput>
                        </FormGroup>
                        <FormGroup>
                            <FormLabel for="phone">연락처</FormLabel>
                            <FormInput type="tel" id="phone" placeholder="연락처를 입력하세요" v-model="formData.phone">
                            </FormInput>
                        </FormGroup>
                    </FormRow>
                </RegistrationFormContainer>
            </ModalBody>
            <ModalFooter>
                <ModalButton @click="handleSubmit" class="primary">등록</ModalButton>
                <ModalButton @click="$emit('close')" class="secondary">취소</ModalButton>
            </ModalFooter>
        </ModalContent>
    </ModalOverlay>
</template>

<script>
import * as RecipientRegistrationModalCss from '@/assets/styles/claim/modal/RecipientRegistrationModalCss.js';

export default {
    name: 'RecipientRegistrationModal',

    components: {
        ...RecipientRegistrationModalCss,
    },

    data() {
        return {
            formData: {
                beneficiaryName: '',
                number: '',
                cnum: '',
                target: '',
                address: '',
                address_detail: '',
                guard_name: '',
                guard_target: '',
                manager: '',
                phone: '',
                type: '비급여'
            }
        };
    },

    computed: {
        isFormValid() {
            return this.formData.beneficiaryName.trim() &&
                this.formData.number.trim() &&
                this.formData.cnum.trim() &&
                this.formData.address.trim() &&
                this.formData.manager.trim() &&
                this.formData.phone.trim();
        }
    },

    methods: {
        searchAddress() {
            new window.daum.Postcode({
                oncomplete: (data) => {
                    this.formData.address = data.address;
                    this.$nextTick(() => {
                        document.getElementById('address_detail').focus();
                    });
                }
            }).open();
        },

        async handleSubmit() {
            if (!this.isFormValid) {
                this.$swal.fire({
                    title: '입력 오류',
                    text: '필수 항목을 모두 입력해주세요.',
                    icon: 'warning',
                    confirmButtonText: '확인'
                });
                return;
            }

            try {
                const requestData = {
                    name: this.formData.beneficiaryName,
                    companykey: this.$globalState.company_key,
                    number: this.formData.number,
                    target: this.formData.target,
                    address: this.formData.address,
                    address_detail: this.formData.address_detail,
                    guard_name: this.formData.guard_name,
                    guard_target: this.formData.guard_target,
                    manager: this.formData.manager,
                    phone: this.formData.phone,
                    type: this.formData.type
                };

                const response = await this.$axios({
                    method: 'post',
                    url: `${this.$apiUrls.hanqmedi}/registerRecipient`,
                    data: requestData,
                    headers: {
                        'Authorization': `Bearer ${localStorage.getItem('token')}`,
                        'Content-Type': 'application/json'
                    }
                });

                if (response.data && response.data.success) {
                    await this.$swal.fire({
                        title: '등록 완료',
                        text: `"${this.formData.beneficiaryName}" 고객이 성공적으로 등록되었습니다.`,
                        icon: 'success',
                        confirmButtonText: '확인'
                    });

                    this.$emit('submit', this.formData);
                    this.resetForm();
                } else {
                    throw new Error(response.data?.message || '고객 등록에 실패했습니다.');
                }

            } catch (error) {
                console.error('고객 등록 오류:', error);

                let errorMessage = '고객 등록 중 오류가 발생했습니다.';
                let errorTitle = '등록 실패';

                if (error.response?.data?.message) {
                    errorMessage = error.response.data.message;
                } else if (error.message) {
                    errorMessage = error.message;
                }

                if (error.response?.status === 400) {
                    errorTitle = '입력 오류';
                    if (error.response.data?.missingFields) {
                        const missingFields = Object.keys(error.response.data.missingFields);
                        errorMessage = `필수 필드가 누락되었습니다: ${missingFields.join(', ')}`;
                    }
                } else if (error.response?.status === 401) {
                    errorTitle = '인증 오류';
                } else if (error.response?.status === 500) {
                    errorTitle = '서버 오류';
                }

                this.$swal.fire({
                    title: errorTitle,
                    text: errorMessage,
                    icon: 'error',
                    confirmButtonText: '확인',
                    showCloseButton: true
                });
            }
        },

        resetForm() {
            this.formData = {
                beneficiaryName: '',
                number: '',
                cnum: '',
                target: '',
                address: '',
                address_detail: '',
                guard_name: '',
                guard_target: '',
                manager: '',
                phone: ''
            };
        }
    }
};
</script>